import { render, staticRenderFns } from "./HeadMetadata.vue?vue&type=template&id=15750914"
import script from "./HeadMetadata.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeadMetadata.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports